<template>
  <div class="credit">
    <div class="credit_tab">
      <div
        :class="['credit_tab_item', tabIndex == item.id ? 'line' : '']"
        :data-tab="item.id"
        v-for="item in tabList"
        :key="item.id"
        @click="chooseTab($event)"
      >
        {{ item.tab }}
      </div>
    </div>
    <div class="credit_con" v-show="tabIndex == 1">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ background: '#409EFF', color: '#ffffff' }"
      >
        <el-table-column prop="enterpriseName" label="企业名称" width="380">
        </el-table-column>
        <el-table-column prop="enterpriseCode" label="社会信用代码" width="280">
        </el-table-column>
        <!-- <el-table-column prop="isDishonesty" label="企业失信">
          <template slot-scope="scope">
            {{ scope.row.isDishonesty?'是':'否' }}
          </template>
        </el-table-column> -->
        <el-table-column prop="isBlacklist" label="企业黑名单">
          <template slot-scope="scope">
            {{ scope.row.isBlacklist}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="score" label="评分">
          <template slot-scope="scope">
            <i v-for="(item,index) in (scope.row.score)" :key="index" class="el-icon-star-on" style="color:gold;"></i>
          </template>
        </el-table-column> -->
        <el-table-column prop="data" label="日期"> </el-table-column>
      </el-table>
    </div>
    <div class="credit_con" v-show="tabIndex == 2">
      <div
        @click="goLink(item.link)"
        class="credit_enter_item"
        v-for="(item, index) in creditEnter"
        :key="index"
      >
        <img :src="item.img" alt="" />
        <div>{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      tabIndex: 1,
      tabList: [
        {
          tab: "信用公示",
          id: "1",
        },
        {
          tab: "查询入口",
          id: "2",
        },
      ],
      creditEnter: [
        {
          text: "统一社会信用代码查询",
          link: "https://www.creditchina.gov.cn/xinyongfuwu/tongyishehuixinyongdaimachaxunzhuanlan/",
          img: require("../../static/other/credit_1.jpg"),
        },
        {
          text: "守信激励代码查询",
          link: "https://www.creditchina.gov.cn/xinyongfuwu/shouxinhongmingdan/",
          img: require("../../static/other/credit_2.jpg"),
        },
        {
          text: "失信被执行人",
          link: "http://zxgk.court.gov.cn/shixin/",
          img: require("../../static/other/credit_3.jpg"),
        },
      ],
      tableData: [
        {
          enterpriseName: "鄂伦春自治旗伟达工程机械设备租赁有限公司",
          enterpriseCode: "91150723MACMULLQ6F",
          isBlacklist: "否",
          data: "2023年6月26日",
        },
        {
          enterpriseName: "江苏联方钢结构工程有限公司",
          enterpriseCode: "91320312717419810A",
          isBlacklist: "否",
          data: "2023年6月26日",
        },
        
        {
          enterpriseName: "衡水芳辉金属制品有限公司",
          enterpriseCode: "91131127MA0DQ2QU73",
          isBlacklist: "否",
          data: "2023年6月24日",
        },
        {
          enterpriseName: "徐州市三华钢结构工程有限公司",
          enterpriseCode: "91320312793810942A",
          isBlacklist: "否",
          data: "2023年6月20日",
        },
       
        {
          enterpriseName: "佛山市星舰智能装备有限公司",
          enterpriseCode: "91440606MAC787DA2Y",
          isBlacklist: "否",
          data: "2023年6月19日",
        },
        {
          enterpriseName: "包头三钐稀土有限公司",
          enterpriseCode: "91150207MA0PTDJ63R",
          isBlacklist: "否",
          data: "2023年6月16日",
        },
        
        {
          enterpriseName: "江苏天阖建设科技有限公司",
          enterpriseCode: "91320300MA213P719K",
          isBlacklist: "否",
          data: "2023年6月15日",
        },
        {
          enterpriseName: "太原安装工程集团有限公司",
          enterpriseCode: "91140100110070958L",
          isBlacklist: "否",
          data: "2023年6月15日",
        },
        
        {
          enterpriseName: "河北铁媒铁路设备有限公司",
          enterpriseCode: "91130182MA0FX6NE8E",
          isBlacklist: "否",
          data: "2023年6月15日",
        },
        {
          enterpriseName: "南京火燥机械科技有限公司",
          enterpriseCode: "91320113MA1MXYC16G",
          isBlacklist: "否",
          data: "2023年6月14日",
        },
        {
          enterpriseName: "内蒙古亿诚工业有限公司",
          enterpriseCode: "91150207MAC46BRFXB",
          isBlacklist: "否",
          data: "2023年6月14日",
        },
        {
          enterpriseName: "山东一滕建设集团有限公司",
          enterpriseCode: "913709837409658000",
          isBlacklist: "否",
          data: "2023年6月12日",
        },
        
        {
          enterpriseName: "中益诚达建设集团有限公司",
          enterpriseCode: "91130230782576898R",
          isBlacklist: "否",
          data: "2023年6月12日",
        },
        // {
        //   enterpriseName: "中益诚达建设集团有限公司",
        //   enterpriseCode: "91130230782576898R",
        //   isBlacklist: "否",
        //   data: "2023年6月12日",
        // },
        // {
        //   enterpriseName: "山东一滕建设集团有限公司",
        //   enterpriseCode: "913709837409658000",
        //   isBlacklist: "否",
        //   data: "2023年6月9日",
        // },
        // {
        //   enterpriseName: "采合（北京）进出口有限公司",
        //   enterpriseCode: "91110105MA01HM2H20",
        //   isBlacklist: "否",
        //   data: "2023年6月6日",
        // },
        // {
        //   enterpriseName: "深圳市思达优悦企业管理顾问有限公司",
        //   enterpriseCode: "91440300553892053B",
        //   isBlacklist: "否",
        //   data: "2023年6月5日",
        // },
        // {
        //   enterpriseName: "重庆右维科技有限公司",
        //   enterpriseCode: "91500120MA61AWQF9F",
        //   isBlacklist: "否",
        //   data: "2023年6月1日",
        // },
        // {
        //   enterpriseName: "重庆右维科技有限公司",
        //   enterpriseCode: "91500120MA61AWQF9F",
        //   isBlacklist: "否",
        //   data: "2023年6月1日",
        // },
        // {
        //   enterpriseName: "采合（北京）进出口有限公司",
        //   enterpriseCode: "91110105MA01HM2H20",
        //   isBlacklist: "否",
        //   data: "2023年5月25日",
        // },
        // {
        //   enterpriseName: "宁夏华瑞诚建筑工程有限公司",
        //   enterpriseCode: "91640500MA76JT6M6M",
        //   isBlacklist: "否",
        //   data: "2023年5月19日",
        // },
        // {
        //   enterpriseName: "江苏天阖建设科技有限公司",
        //   enterpriseCode: "91320300MA213P719K",
        //   isBlacklist: "否",
        //   data: "2023年5月19日",
        // },
        // {
        //   enterpriseName: "宁夏远桥建设工程有限公司",
        //   enterpriseCode: "91640500352679846R",
        //   isBlacklist: "否",
        //   data: "2023年5月19日",
        // },
        // {
        //   enterpriseName: "宁夏远桥建设工程有限公司",
        //   enterpriseCode: "91640500352679846R",
        //   isBlacklist: "否",
        //   data: "2023年5月18日",
        // },
        // {
        //   enterpriseName: "中益诚达建设集团有限公司",
        //   enterpriseCode: "91130230782576898R",
        //   isBlacklist: "否",
        //   data: "2023年5月18日",
        // },
        // {
        //   enterpriseName: "中益诚达建设集团有限公司",
        //   enterpriseCode: "91130230782576898R",
        //   isBlacklist: "否",
        //   data: "2023年5月18日",
        // },
        // {
        //   enterpriseName: "牙克石市一间办公用品商行",
        //   enterpriseCode: "92150782MABWR92N9Q",
        //   isBlacklist: "否",
        //   data: "2023年5月17日",
        // },
        // {
        //   enterpriseName: "宁夏远桥建设工程有限公司",
        //   enterpriseCode: "91640500352679846R",
        //   isBlacklist: "否",
        //   data: "2023年5月16日",
        // },
        // {
        //   enterpriseName: "大连品库电子商务有限公司",
        //   enterpriseCode: "91210242MA10RRTR5N",
        //   isBlacklist: "否",
        //   data: "2023年5月16日",
        // },
        // {
        //   enterpriseName: "山东一滕建设集团有限公司",
        //   enterpriseCode: "913709837409658000",
        //   isBlacklist: "否",
        //   data: "2023年5月15日",
        // },
        // {
        //   enterpriseName: "山东一滕建设集团有限公司",
        //   enterpriseCode: "913709837409658000",
        //   isBlacklist: "否",
        //   data: "2023年5月15日",
        // },
        // {
        //   enterpriseName: "内蒙古自治区凯城道路工程有限责任公司",
        //   enterpriseCode: "91150721MABN79A98J",
        //   isBlacklist: "否",
        //   data: "2023年5月6日",
        // },
        // {
        //   enterpriseName: "云南山诺建筑工程有限公司",
        //   enterpriseCode: "915301000933206000",
        //   isBlacklist: "否",
        //   data: "2023年4月22日",
        // },
        // {
        //   enterpriseName: "内蒙古美航网络科技有限公司",
        //   enterpriseCode: "91150118MA0Q7EE57X",
        //   isBlacklist: "否",
        //   data: "2023年4月21日",
        // },
        // {
        //   enterpriseName: "中天昊建设管理集团股份有限公司",
        //   enterpriseCode: "91370502668055538G",
        //   isBlacklist: "否",
        //   data: "2023年4月20日",
        // },
        // {
        //   enterpriseName: "山西星源建设有限公司",
        //   enterpriseCode: "91149900MA0LAM3MX5",
        //   isBlacklist: "否",
        //   data: "2023年4月18日",
        // },
        // {
        //   enterpriseName: "内蒙古大钲建设有限公司",
        //   enterpriseCode: "91150428MA0RTHKM3Q",
        //   isBlacklist: "否",
        //   data: "2023年4月10日",
        // },
        // {
        //   enterpriseName: "根河市新昌建筑安装有限公司",
        //   enterpriseCode: "91150785783012197L",
        //   isBlacklist: "否",
        //   data: "2023年4月6日",
        // },
        // {
        //   enterpriseName: "河南庆德达建设有限公司",
        //   enterpriseCode: "91411681MA40UFAQ5J",
        //   isBlacklist: "否",
        //   data: "2023年4月6日",
        // },
        // {
        //   enterpriseName: "内蒙古中泰餐饮有限公司",
        //   enterpriseCode: "91150207085193066L",
        //   isBlacklist: "否",
        //   data: "2023年4月4日",
        // },
        // {
        //   enterpriseName: "克什克腾旗融创生态产业发展有限公司",
        //   enterpriseCode: "91150425MAC72JH81P",
        //   isBlacklist: "否",
        //   data: "2023年4月3日",
        // },
        // {
        //   enterpriseName: "太原中快餐饮管理有限公司",
        //   enterpriseCode: '911401005710995000',
        //   isBlacklist: "否",
        //   data: "2023年4月2日",
        // },
        // {
        //   enterpriseName: "江苏盛徽建设工程有限公司",
        //   enterpriseCode: "91321182MA1MBT649W",
        //   isBlacklist: "否",
        //   data: "2023年3月28日",
        // },
        // {
        //   enterpriseName: "南京全力建设有限公司",
        //   enterpriseCode: "91320111552058390D",
        //   isBlacklist: "否",
        //   data: "2023年3月28日",
        // },
        // {
        //   enterpriseName: "江苏逞亮建设有限公司",
        //   enterpriseCode: "91321182681641515P",
        //   isBlacklist: "否",
        //   data: "2023年3月23日",
        // },
        // {
        //   enterpriseName: "上海威固建筑科技有限公司",
        //   enterpriseCode: "91310112669409692J",
        //   isBlacklist: "否",
        //   data: "2023年3月22日",
        // },
        // {
        //   enterpriseName: "上海砼力建筑工程技术有限公司",
        //   enterpriseCode: "91310114583408031G",
        //   isBlacklist: "否",
        //   data: "2023年3月22日",
        // },
        // {
        //   enterpriseName: "南京新筑加固工程有限公司",
        //   enterpriseCode: '913201057482208000',
        //   isBlacklist: "否",
        //   data: "2023年3月16日",
        // },
        // {
        //   enterpriseName: "上海劲豪建设工程有限公司",
        //   enterpriseCode: "913102307895637000",
        //   isBlacklist: "否",
        //   data: "2023年3月16日",
        // },
        // {
        //   enterpriseName: "江苏建科土木工程技术有限公司",
        //   enterpriseCode: "91320000661788931R",
        //   isBlacklist: "否",
        //   data: "2023年3月15日",
        // },
       
      ],
    };
  },
  computed: {},
  watch: {
    $route: {
      handler: function (val) {
        this.tabIndex = val.query.tabIndex;
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    let tabIndex = this.$route.query.tabIndex;
    this.tabIndex = tabIndex;

  },
  mounted() {},
  methods: {
    chooseTab(e) {
      let tabIndex = e.target.dataset.tab;
      this.tabIndex = tabIndex;
      
    },
    goLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped >
.credit {
  width: 1200px;
  margin: auto;
}
.credit_tab {
  display: flex;
  justify-content: center;
  align-items: center;
}
.credit_tab_item {
  flex-grow: 1;
  margin-left: 10px;
  cursor: pointer;
  text-align: center;
  height: 60px;
  line-height: 60px;
  font-size: 20px;
}
.line {
  border-bottom: 3px solid rgb(26, 127, 221);
  color: rgb(26, 127, 221);
}
.credit_con {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 100px 0;
}
.credit_enter_item {
  width: 275px;
  height: 175px;
  position: relative;
  margin-right: 50px;
  cursor: pointer;
}
.credit_enter_item > div {
  height: 40px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
  text-align: center;
  line-height: 40px;
  font-weight: 600;
}
</style>
